import styled from "styled-components";

export const PhaseSummaryWrapper = styled.div`
    margin-bottom: 1.5rem;
    display: flex;
    flex-direction: column;
    width: 100%;
    gap: 1.5rem;
`;
